<ng-template #myTemplate1>
  <hr>
  <h2> Certain autoimmune or viral conditions can increase T1D risk</h2>
  <p>The exact cause of type 1 diabetes isn’t known—and that means many of the risk factors are unknown too. But certain
    other conditions can&nbsp;increase T1D risk.</p>
  <div class="content-2 d-flex flex-column flex-lg-row justify-content-start align-items-center mt-5">
    <div class="content-2__image flex-shrink-0">
      <picture [data]=" {
          image: 'whatsyourtd1risk/meter',
          webp: true,
          altext: 'A scale',
          format: '',
          width: '200',
          height: '111',
          mobile: false,
          classes: 'img-fluid',
        }"></picture>
    </div>
    <div class="content-2__bullet-boxes d-flex flex-column flex-lg-column gap-4">
      <div class="bullet-box bullet-box--1">
        <p>Some of these conditions that may increase T1D risk are viruses like Coxsackievirus B, Rotavirus, Mumps, and
          a virus related to herpes called cytomegalovirus (CMV).</p>
      </div>
      <div class="bullet-box bullet-box--1">
        <p>Having an autoimmune condition, like Celiac, Graves or Hashimoto's disease, or a history of autoimmune
          conditions in your family could also increase T1D risk.</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #myTemplate2>
  <hr>
  <h2>Type 1 diabetes can happen at any age—even as an adult</h2>
  <div class="content-3 d-flex flex-column flex-lg-row justify-content-start align-items-center mt-5">
    <div class="content-3__image content-3__image--sand-clock flex-shrink-0 order-1 order-lg-0">
      <picture [data]=" {
          image: 'whatsyourtd1risk/sand-clock',
          webp: true,
          altext: 'An hourglass timer',
          format: '',
          width: '97',
          height: '151',
          mobile: false,
          classes: 'img-fluid sand-clock-img',
        }"></picture>
    </div>
    <div class="content-3__text d-flex flex-column flex-lg-row gap-4 order-0 order-lg-1">
      <p>Some people think of type 1 diabetes as a children’s disease—more likely to affect kids. But over half the
        people who are newly diagnosed with type 1 diabetes get diagnosed as adults. That means that you or a loved one
        could still be at risk for T1D—at any age.</p>
    </div>
  </div>
</ng-template>

<ng-template #myTemplate3>
  <hr>
  <h2>T1D may progress more rapidly in young children</h2>
  <div class="content-3 d-flex flex-column flex-lg-row justify-content-start align-items-center mt-5">
    <div class="content-3__image content-3__image--stairs flex-shrink-0 order-1 order-lg-0">
      <picture [data]=" {
          image: 'whatsyourtd1risk/stairs',
          webp: true,
          altext: 'A rising bar graph',
          format: '',
          width: '172',
          height: '109',
          mobile: false,
          classes: 'img-fluid stairs-img',
        }"></picture>
    </div>
    <div class="content-3__text d-flex flex-column flex-lg-row gap-4 order-0 order-lg-1">
      <p>While T1D can affect anyone, the window between Stage 1 T1D and Stage 4 insulin-dependent T1D can be rapid and
        severe for young children especially, with many young patients first being diagnosed in emergency situations.
        Younger children, especially those &lt;7 years old, often experience more rapid progression of T1D and often
        lose beta-cell function more quickly around diagnosis compared with adolescents.</p>
    </div>
  </div>
</ng-template>


<div container>
  <div class="section1__container bg-white position-relative">
    <div class="section1__content__container">
      <h2>Type 1 diabetes (T1D) can happen to anyone</h2>
      <p>Type 1 diabetes is an autoimmune disease and, unlike type 2 diabetes, is not caused by diet or lifestyle. T1D
        can develop in<br class="d-none d-lg-block" /> anyone no matter their age, family history, or lifestyle choices.
        But if just 1 family member has T1D,
        your risk multiplies by up to 15X.</p>
      <div class="content-1 d-flex flex-column flex-lg-row justify-content-start align-items-center mt-5">
        <div class="content-1__image flex-shrink-0">
          <picture [data]=" {
            image: 'whatsyourtd1risk/content-1-image',
            webp: true,
            altext: 'A network of people',
            format: '',
            width: '194',
            height: '194',
            mobile: false,
            classes: 'img-fluid',
          }"></picture>
        </div>
        <div class="content-1__info-boxes d-flex flex-row flex-lg-column gap-4">
          <div class="info-box info-box--1 d-flex flex-column flex-lg-row">
            <div
              class="left-side bg-secondary text-white d-flex flex-column flex-lg-row flex-shrink-0 align-items-center justify-content-center">
              <span class="pt-2">Up to&nbsp;&nbsp;&nbsp;</span><span class="h1 mb-0">90%</span>
            </div>
            <div class="right-side w-100 d-flex justify-content-center align-items-center text-center">
              <div> of people diagnosed have <span class="fw-bold">no family history</span></div>
            </div>
          </div>
          <div class="info-box info-box--2 d-flex flex-column flex-lg-row">
            <div
              class="left-side bg-primary text-white d-flex flex-column flex-lg-row flex-shrink-0 align-items-center justify-content-center">
              <span class="pt-2">Up to&nbsp;&nbsp;&nbsp;</span><span class="h1 mb-0">15x</span>
            </div>
            <div class="right-side w-100 d-flex justify-content-center align-items-center text-center">
              <div>higher risk if <span class="fw-bold">even 1 family member</span> has T1D</div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngTemplateOutlet="myTemplate1"></ng-container>

      <ng-container *ngTemplateOutlet="myTemplate2"></ng-container>

      <ng-container *ngTemplateOutlet="myTemplate3"></ng-container>

    </div>
  </div>
</div>